export default __webpack_public_path__ + "static/media/sentIcon.9b90e286.svg";